<template>
    <div>
        <el-row class="cs-contentContainer">
            <el-col :span="4" class="cs-main-left-container">
                <navigator></navigator>
            </el-col>
            <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
                <div class="cs-fullHeight cs-contentContainer-right">
                    <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                        <el-row>
                            <el-col>
                                <span class="cs-title">学生广告管理</span>
                              <div class="cs-fullheight cs-pagination-container" style="margin-bottom:10px;">
                                <div class="cs-pagination-header">
                                  <el-button class="cs-pagination-header-add" v-on:click="add()"  type="primary" plain icon="el-icon-plus">添加广告</el-button>
                                </div>
                              </div>
                              <div class="cs-pagination-table-container">
                                       <el-col :span="6" class="block cs-student-adItem"  v-for="(ad,key,index) in advertistings" :key="index ">

                                         <image-show center
                                            :src="ad.PictureUrl"  @click="onPriview(ad.PictureUrl)"
                                            :isVisible="true"
                                            class="cs-student-adItem-imageContainer"
                                          ></image-show>

                                        <div class="bottom clearfix">
                                          <el-button type="text" class="button" v-on:click="onChange(ad)">{{ad.IsActive?'可用':'不可用'}}</el-button>
                                          <el-button type="text" class="button" v-on:click="edit(index,ad)">修改</el-button>
                                          <el-button type="text" class="button" @click="onDelete(ad.Id)">删除</el-button>
                                        </div>

                                    </el-col>
                              </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh">
          <adEdit :data="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess"></adEdit>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.cs-pagination-table-container{
  .cs-student-adItem{
    padding-right:50px;
  }

  .cs-student-adItem-imageContainer{
    height:160px;
    width:200px;

    /deep/  .cs-demo-image-container{
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<script>
import navigator from "../../components/navigator";
import adEdit from "../../components/studentAdvertisement/adEdit";
import { queryAd,delAd,switchAdEnabled,editAd } from "../../service/studentAd.service";
import imageShow from "@/components/fileHandler/imageShow";

export default {
  data() {
    return {
      loading: false,
      advertistings:[],
      editData:{},
      dialogEditorVisible: false,
      queryCondition: {
        KeyWord: null,
        PageSize: 1000,
        PageNumber: 1
      }
    };
  },
  components: {
    navigator,
    adEdit,
    imageShow
  },
  computed: {},
  created() {
    this.getAll();
  },
  methods: {
    getAll(){
      this.loading=true;
      queryAd(this.queryCondition).then(result=>
            {
              if (result && result.success) {
                this.advertistings=result.data.Results;
                this.loading=false;
              }
      })
    },
    async onChange(advertisting){
      if(advertisting.IsActive){
        await this.onDisable(advertisting);
      }else{
        await this.onEnable(advertisting);
      }
    },
    async onDisable(advertisting){
      this.loading=true;
      await switchAdEnabled(advertisting.Id, false);
      advertisting.IsActive=false;
      this.loading=false;
    },
    async onEnable(advertisting){
      this.loading=true;
      await switchAdEnabled(advertisting.Id, true);
      advertisting.IsActive=true;
      this.loading=false;
    },
    async onDelete(id){
      this.$confirm("您确认要删除该广告吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(async () => {
            await delAd(id);
            this.getAll();
          })
      .catch(() => {});

    },
    onCloseEditor(){
      this.dialogEditorVisible = false;

    },
    onSaveSuccess(isAdd, row){
      this.dialogEditorVisible = false;
      this.getAll();
    },
     add() {
      this.editData = {};
      this.dialogEditorVisible = true;
    },
    edit(index, row) {
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    onPriview(pictureUrl){
      window.open(pictureUrl, "_blank");
    }
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/studentAdvertisement.vue